export const formatPlanDaysLeft = (planExpireAt, planDaysLeft) => {
  const exp = new Date(planExpireAt).getTime() / 1e3;
  const now = new Date().getTime() / 1e3;
  const differ = parseInt(`${(exp - now) / 60 / 60 / 24}`) + 1;
  const result = parseInt(`${planDaysLeft}`) === 0 ? 0 : differ > 0 && differ < 1 ? 1 : planDaysLeft === null ? planDaysLeft : differ;
  return result;
};
